import { UnitStatus } from './unit.model';
import { ImmutableMap, QueryParams } from './utility.model';

export const REPORT_STATUS = ['notProcessed', 'generatingPdf', 'pdfGenerationFailed', 'completed'] as const;
export type ReportStatus = (typeof REPORT_STATUS)[number];

export type ReportUnit = {
  unitId: string;
  name: string;
  status: UnitStatus;
  updatedAt: string;
};

type ReportProvidedProps = {
  version: number;
  fileName: string;
  units: ReportUnit[];
  lang: string;
  date: string;
  departmentName: string;
  userId: string;
  userName: string;
  createdAt: number;
  status: ReportStatus;
};

export type ReportQueryParams = QueryParams & { projectId: string };

export type Report = ReportProvidedProps;

export class Reports extends ImmutableMap<string, Report> {
  constructor(reports?: Report[] | Iterable<Report>) {
    super((report: Report) => report.fileName, reports);
  }

  protected clone(reports?: Report[] | Iterable<Report>): this {
    return new Reports(reports) as this;
  }
}
